import { AppFeatures } from '@urbanx/agx-ui-components'
import AgenciesService from 'services/agenciesService'

const GetFeatureToggles = async (
  getAuthToken: () => Promise<string>,
  campaignId?: string,
  
): Promise<AppFeatures | undefined> => {
  if (!campaignId) return

  const token = await getAuthToken()

  const service = new AgenciesService(token)
  
  const { data: featureToggles } = await service.agencyService.get(
    'StaffGetFeatureToggles',
    { campaignId }
  )

  return featureToggles || {}
}

export default GetFeatureToggles
